// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FeedbackDetails.css */

.modal-content {
    border-radius: 10px;
  }
  
  .modal-header {
    background-color: #a9cbaa ;
    color: #000000;
    border-bottom: none;
    font-weight: bold;
  }
  
  .modal-title {
    font-size: 1.25rem;
  }
  
  .modal-body {
    font-size: 1rem;
  }
  
  .modal-footer {
    border-top: none;
  }
  
  .modal-body p {
    margin-bottom: 8px;
  }
  
  .modal-body strong {
    font-weight: bold;
  }
  
  .badge {
    font-size: 0.9rem;
    padding: 6px 10px;
    border-radius: 6px;
  }
  
  .badge-danger {
    background-color: #dc3545;
  }
  
  .badge-success {
    background-color: #28a745;
  }
  
/* FeedbackDetails.css */

.details-group {
    margin-bottom: 20px;
    background-color: whitesmoke;
    padding: 10px;
    border-radius: 10px;
  }
  
  .details-group h5 {
    font-size: 1.1rem;
    margin-bottom: 10px;
  }
  
  .details-group p {
    margin-bottom: 8px;
  }
  
  .details-group strong {
    font-weight: bold;
  }
  
  .modal-footer .btn-secondary {
    background-color: #6c757d;
    color: white;
    border: none;
  }
  
  .modal-footer .btn-secondary:hover {
    background-color: #5a6268;
    color: white;
  }
  
  .status-dropdown {
    margin-top: 5px;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/Components/FeedbackDetails/FeedbackDetails.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;AAEF,wBAAwB;;AAExB;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB","sourcesContent":["/* FeedbackDetails.css */\r\n\r\n.modal-content {\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .modal-header {\r\n    background-color: #a9cbaa ;\r\n    color: #000000;\r\n    border-bottom: none;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .modal-title {\r\n    font-size: 1.25rem;\r\n  }\r\n  \r\n  .modal-body {\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .modal-footer {\r\n    border-top: none;\r\n  }\r\n  \r\n  .modal-body p {\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .modal-body strong {\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .badge {\r\n    font-size: 0.9rem;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n  }\r\n  \r\n  .badge-danger {\r\n    background-color: #dc3545;\r\n  }\r\n  \r\n  .badge-success {\r\n    background-color: #28a745;\r\n  }\r\n  \r\n/* FeedbackDetails.css */\r\n\r\n.details-group {\r\n    margin-bottom: 20px;\r\n    background-color: whitesmoke;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .details-group h5 {\r\n    font-size: 1.1rem;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .details-group p {\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .details-group strong {\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .modal-footer .btn-secondary {\r\n    background-color: #6c757d;\r\n    color: white;\r\n    border: none;\r\n  }\r\n  \r\n  .modal-footer .btn-secondary:hover {\r\n    background-color: #5a6268;\r\n    color: white;\r\n  }\r\n  \r\n  .status-dropdown {\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
